import { StyleSheet } from 'react-native';

import { ds } from '@/components/lib/design.system';

const WIDTH = 48;
const HEIGHT = 36;

export const paymentMethodStyles = StyleSheet.create({
    listItem: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center',
        paddingVertical: 16,
        marginHorizontal: 16,
    },
    lineItemBorder: {
        borderBottomWidth: 1,
        borderBottomColor: ds.colorValue.border.strong,
    },
    imageContainer: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: WIDTH,
        height: HEIGHT,
        marginRight: 16,
    },
    image: {
        width: '100%',
        height: '100%',
    },
    icon: {
        width: WIDTH,
        height: HEIGHT,
        borderWidth: 1,
        borderColor: ds.colorValue.border.strong,
        borderRadius: 8,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    footerContainer: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center',
        height: 40,
        paddingRight: 8,
    },
});
